import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { rupiah, tanggalID } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { toast } from "sonner";
import { RotateCcw, Trash2 } from "lucide-react";
import Pagination, { usePagination } from "@/components/app/Pagination";

function Section({ items, type, label, onReload }) {
  const { page, setPage, totalPages, paged, total, pageSize } = usePagination(items, 10);
  const restore = async (id) => {
    try { await api.post(`/${type}/${id}/restore`); onReload(); toast.success("Dipulihkan"); }
    catch(e){ toast.error(formatApiError(e)); }
  };
  const hard = async (id) => {
    if (!window.confirm("Hapus permanen? Tidak bisa dikembalikan.")) return;
    try { await api.delete(`/trash/${type}/${id}`); onReload(); toast.success("Terhapus permanen"); }
    catch(e){ toast.error(formatApiError(e)); }
  };
  return (
    <div className="card-flat overflow-hidden">
      <div className="px-5 py-3 border-b font-semibold text-sm">{label} ({items.length})</div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid={`trash-${type}-table`}>
          <thead><tr className="bg-slate-50 border-b text-left text-[11px] uppercase text-slate-500">
            <th className="p-3">Tanggal</th><th className="p-3">Nama</th>
            <th className="p-3 text-right">Nominal</th><th className="p-3">Dihapus</th>
            <th className="p-3 text-right">Aksi</th>
          </tr></thead>
          <tbody>
            {paged.length===0 && <tr><td colSpan="5" className="text-center py-8 text-slate-400">Kosong.</td></tr>}
            {paged.map(it => (
              <tr key={it.id} className="border-b">
                <td className="p-3">{tanggalID(it.tanggal)}</td>
                <td className="p-3">{it.nama_barang || it.nama_vendor}</td>
                <td className="p-3 text-right font-mono">{rupiah(it.total || it.nominal)}</td>
                <td className="p-3 text-[11px] text-slate-500">{new Date(it.deleted_at).toLocaleString("id-ID")}</td>
                <td className="p-3 text-right">
                  <div className="flex gap-1 justify-end">
                    <button onClick={()=>restore(it.id)} className="p-1.5 rounded-sm hover:bg-emerald-50" title="Pulihkan"><RotateCcw size={14} className="text-emerald-600"/></button>
                    <button onClick={()=>hard(it.id)} className="p-1.5 rounded-sm hover:bg-rose-50" title="Hapus permanen"><Trash2 size={14} className="text-rose-600"/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination page={page} setPage={setPage} totalPages={totalPages} total={total} pageSize={pageSize} testid={`trash-${type}-pagination`}/>
    </div>
  );
}

export default function Trash() {
  const [d, setD] = useState({ pemasukan: [], pengeluaran: [] });
  const load = async () => setD((await api.get("/trash")).data);
  useEffect(() => { load(); }, []);
  return (<>
    <PageHeader title="Kotak Sampah" subtitle="Pulihkan atau hapus permanen data yang telah dihapus."/>
    <div className="p-4 md:p-8 space-y-6">
      <Section items={d.pemasukan} type="pemasukan" label="Pemasukan Terhapus" onReload={load}/>
      <Section items={d.pengeluaran} type="pengeluaran" label="Pengeluaran Terhapus" onReload={load}/>
    </div>
  </>);
}
